(function () {
  'use strict';

  if (window.BundleProduct) return;

  // _bundle_labels를 잇는 구분자. 카트 템플릿(cart-items.liquid 등)이 이 문자열로
  // 다시 쪼갠다 — 한쪽만 바꾸면 표시가 깨진다. (hapakristinjp.liquid의
  // minibundle.js와 동일 계약 — docs/feature-bundle-cart-transform.md §2)
  var LABEL_SEPARATOR = ' / ';

  // 라벨 안에 구분자와 같은 문자열이 들어가면 카트 표시가 한 줄씩 밀린다.
  // 상품명은 운영자가 바꾸는 값이므로 여기서 막는다.
  function sanitizeLabel(value) {
    return String(value == null ? '' : value).split(LABEL_SEPARATOR).join(' ');
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(sectionEl) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var dataEl = document.getElementById('BundleData-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[BundleProduct] BundleData JSON parse error', e);
      return;
    }

    var slotState = {};
    var slotEls = $$('[data-bundle-slot]', sectionEl);
    var totalSlots = slotEls.length;

    slotEls.forEach(function (slotEl) {
      initSlot(slotEl, slotState, function () {
        updateProgress(sectionEl, slotState, totalSlots);
      });
    });

    initMediaThumbs(sectionEl);
    updateProgress(sectionEl, slotState, totalSlots);

    var addBtn = $('#BundleAddToCart-' + sectionId, sectionEl);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        submitToCart(sectionEl, data, slotState, totalSlots, slotEls);
      });
    }
  }

  function initSlot(slotEl, slotState, onChange) {
    var slotId = slotEl.getAttribute('data-slot-id');
    var powerSelectEl = $('[data-power-select]', slotEl);
    var statusEl = $('[data-slot-status]', slotEl);

    slotState[slotId] = { variantId: null, power: null };

    var variants = [];
    try {
      variants = JSON.parse(slotEl.getAttribute('data-variants') || '[]');
    } catch (e) {
      console.error('[BundleProduct] slot variants parse error', slotId, e);
    }

    populatePowerSelect(powerSelectEl, variants);

    powerSelectEl.addEventListener('change', function () {
      var variantId = powerSelectEl.value;
      if (!variantId) {
        slotState[slotId].variantId = null;
        slotState[slotId].power = null;
      } else {
        slotState[slotId].variantId = variantId;
        var selectedOpt = powerSelectEl.options[powerSelectEl.selectedIndex];
        slotState[slotId].power = selectedOpt.getAttribute('data-power');
      }
      updateSlotStatus(slotEl, statusEl, slotState[slotId]);
      onChange();
    });
  }

  function populatePowerSelect(selectEl, variants) {
    var placeholderText = selectEl.getAttribute('data-placeholder') || 'Select power';
    var unavailableSuffix = selectEl.getAttribute('data-unavailable-suffix') || ' (out of stock)';

    while (selectEl.options.length) selectEl.remove(0);
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = placeholderText;
    selectEl.appendChild(placeholder);

    variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.setAttribute('data-power', v.power || '');
      opt.textContent = (v.power || '') + (v.available ? '' : unavailableSuffix);
      if (!v.available) opt.disabled = true;
      selectEl.appendChild(opt);
    });
  }

  function updateSlotStatus(slotEl, statusEl, state) {
    var emptyText = statusEl.getAttribute('data-status-empty') || '';
    var completeText = statusEl.getAttribute('data-status-complete') || '';
    if (state.variantId) {
      slotEl.setAttribute('data-slot-complete', 'true');
      statusEl.textContent = completeText;
    } else {
      slotEl.removeAttribute('data-slot-complete');
      statusEl.textContent = emptyText;
    }
  }

  // 전 도수 품절 슬롯이 하나라도 있으면 그 세트는 조립 불가.
  // (bundle-slot.liquid가 slot_product.available == false 일 때 표시)
  function hasUnavailableSlot(sectionEl) {
    return !!sectionEl.querySelector('[data-bundle-slot][data-slot-unavailable]');
  }

  function updateProgress(sectionEl, slotState, totalSlots) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var selected = Object.keys(slotState).filter(function (k) {
      return slotState[k].variantId;
    }).length;
    var remaining = totalSlots - selected;
    var blocked = hasUnavailableSlot(sectionEl);

    var progressEl = $('#BundleProgress-' + sectionId, sectionEl);
    var addBtn = $('#BundleAddToCart-' + sectionId, sectionEl);

    if (progressEl) {
      if (blocked) {
        // 품절 슬롯이 있으면 "あと N つ" 대신 품절 안내로 대체.
        // 이 문구가 없으면 고객은 선택을 덜 한 줄 알고 계속 시도한다.
        progressEl.textContent = progressEl.getAttribute('data-progress-unavailable') || '';
      } else if (remaining === 0) {
        progressEl.textContent = progressEl.getAttribute('data-progress-complete') || '';
      } else {
        var tmpl = progressEl.getAttribute('data-progress-template') || '';
        progressEl.textContent = tmpl.replace('__N__', String(remaining));
      }
    }
    if (addBtn) addBtn.disabled = blocked || (remaining !== 0);
  }

  function initMediaThumbs(sectionEl) {
    var thumbs = $$('.Bundle__MediaThumb', sectionEl);
    if (!thumbs.length) return;
    var mainImg = $('.Bundle__MediaMain img', sectionEl);
    if (!mainImg) return;
    var medias = $$('.Bundle__MediaThumb img', sectionEl);
    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () {
        var src = medias[idx].src.replace(/_200x\./, '_1000x.');
        mainImg.src = src;
      });
    });
  }

  function submitToCart(sectionEl, data, slotState, totalSlots, slotEls) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var addBtn = $('#BundleAddToCart-' + sectionId, sectionEl);
    var errorEl = $('#BundleError-' + sectionId, sectionEl);
    var loaderEl = addBtn ? addBtn.querySelector('.Button__Loader') : null;
    var labelEl = addBtn ? addBtn.querySelector('.Button__Label') : null;

    var labelDefault = (addBtn && addBtn.getAttribute('data-label-default')) || '';
    var labelAdding = (addBtn && addBtn.getAttribute('data-label-adding')) || '';
    var labelAdded = (addBtn && addBtn.getAttribute('data-label-added')) || '';
    var errIncomplete = (addBtn && addBtn.getAttribute('data-error-incomplete')) || '';
    var errCartAdd = (addBtn && addBtn.getAttribute('data-error-cart-add')) || '';
    var errUnavailable = (addBtn && addBtn.getAttribute('data-error-unavailable')) || '';
    var errExpand = (addBtn && addBtn.getAttribute('data-error-expand')) || errCartAdd;

    // 품절 슬롯이 있으면 담기 자체를 막는다. 버튼은 이미 disabled지만,
    // 프로그램적 클릭·이벤트 재발생 등을 대비한 서브밋 단계 가드.
    if (hasUnavailableSlot(sectionEl)) {
      showError(errorEl, errUnavailable || errCartAdd);
      return;
    }

    var selectedKeys = Object.keys(slotState).filter(function (k) { return slotState[k].variantId; });
    if (selectedKeys.length !== totalSlots) {
      showError(errorEl, errIncomplete);
      return;
    }

    hideError(errorEl);
    if (addBtn) addBtn.disabled = true;
    if (loaderEl) loaderEl.classList.remove('hidden');
    if (labelEl) labelEl.textContent = labelAdding;

    // cart-transform 전환(docs/feature-bundle-cart-transform.md): 카트에는 세트
    // 1줄만 담긴다. 구성품은 property로 실리고, 그 1줄을 Cart Transform Function이
    // lineExpand로 펼친다.
    var items = buildCartItems(data, slotState, slotEls);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw j; });
        return res.json();
      })
      .then(function () {
        // 펼쳐졌는지 확인한다. `requiresComponents`(구성품 없이 판매 금지)는 이 구조에서
        // 쓸 수 없음이 hapakristinjp.liquid 실측으로 확인되어(docs/feature-bundle-cart-transform.md
        // §8) 펼치기 실패가 결제까지 흘러가면 구성품 없는 세트 주문이 만들어질 수 있다.
        // 실패 원인은 대개 운영자 조치 대상(허용 구성품 동기화 누락, 앱 등록 해제,
        // 등록 전 상태)이다. 여기서 그 라인을 되돌리는 것이 유일한 방어선이다.
        //
        // ⚠️ 한계: 카트에 이 세트가 이미 여러 줄(같은 상품을 두 번 담기 등) 있으면
        // 아래 탐색은 첫 번째 _bundle_items 라인만 본다 — hapakristinjp.liquid와
        // 동일한 한계다. docs/feature-bundle-cart-transform.md §6 검증 대상.
        return fetch('/cart.js', { credentials: 'include' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var cartItems = (cart && cart.items) || [];
            var line = null;
            for (var i = 0; i < cartItems.length; i++) {
              var props = cartItems[i].properties;
              if (props && props._bundle_items) { line = cartItems[i]; break; }
            }
            if (line && line.has_components) return;

            if (!line) throw { __bundleExpandFailed: true };
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            }).then(function () { throw { __bundleExpandFailed: true }; });
          });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // 기존 카트 드로어 열기 호환
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
        if (labelEl) labelEl.textContent = labelAdded;
        setTimeout(function () {
          if (labelEl) labelEl.textContent = labelDefault;
          if (addBtn) addBtn.disabled = false;
        }, 2000);
      })
      .catch(function (err) {
        console.error('[BundleProduct] cart/add error', err);
        // 422 = Shopify 재고 부족/구매 불가. items[]는 세트 1줄뿐이라 고른 도수의
        // 품절은 여기서 걸리지 않고 카트/체크아웃에서 드러난다(펼치기 단계).
        // 이 422는 세트 상품 자체를 담을 수 없을 때만 난다. Shopify 원문 description은
        // 고객이 페이지에서 찾을 수 없는 상품명을 담고 있어 혼란을 주므로, 새로고침을
        // 안내하는 전용 문구로 치환한다(새로고침하면 Liquid가 최신 available을 다시 렌더).
        var msg;
        if (err && err.__bundleExpandFailed) {
          // 재고 문구로 뭉개면 안 된다 — 고객이 다른 도수를 골라도 해결되지 않는다.
          msg = errExpand;
        } else if (err && (err.status === 422 || err.status === '422')) {
          msg = errUnavailable || errCartAdd;
        } else {
          msg = (err && err.description) || (err && err.message) || errCartAdd;
        }
        showError(errorEl, msg);
        if (addBtn) addBtn.disabled = false;
        if (labelEl) labelEl.textContent = labelDefault;
      })
      .finally(function () {
        if (loaderEl) loaderEl.classList.add('hidden');
      });
  }

  // 고정 구성품(박스구성품·렌즈케이스·증정품 등) 목록.
  // Liquid(bundle-product.liquid)가 bundle.fixed_items를 배열로 내보낸다.
  // 미등록이면 빈 배열 → 구성품 라인 없이 담긴다.
  function getFixedItems(data) {
    return Array.isArray(data.fixedItems) ? data.fixedItems : [];
  }

  // 세트(parent) 카트 라인 1줄을 만든다. 고객이 고른 구성품은 line property로
  // 실어 보내고, 실제로 라인을 펼치는 것은 Cart Transform Function이다.
  //
  // 계약(앱과 동시 수정 — docs/feature-bundle-cart-transform.md §2):
  //   _bundle_items  구성품 variant id를 쉼표로 이은 문자열. 이 키의 존재가 펼치기의 유일한 트리거
  //   _bundle_labels 같은 순서·같은 개수의 표시용 문자열(cart-items.liquid 등이 구성 요약에 씀)
  //   _bundle_v      계약 버전
  //
  // ⚠️ 순서가 계약이다(고정 구성품 → 슬롯 등록 순서). 앱이 세트 가격을 구성품에 나눌 때
  //    나머지를 첫 구성품에 붙이고, 주문서 표시 순서도 이 순서를 따른다. 그래서
  //    슬롯은 Object.keys(slotState)가 아니라 slotEls(DOM = 등록 순서)로 뽑는다 —
  //    지금까지 순서가 맞았던 것은 slotState의 키 삽입 순서가 우연히 DOM 순서와
  //    같았을 뿐이다. 두 배열(ids/labels)은 반드시 같은 루프에서 같이 채운다.
  function buildCartItems(data, slotState, slotEls) {
    var ids = [];
    var labels = [];

    // 1. 고정 구성품 (선택 — 등록된 것만, 등록 순서대로. 개수 제한 없음)
    getFixedItems(data).forEach(function (item) {
      if (!item || !item.variantId) return;
      ids.push(item.variantId);
      labels.push(sanitizeLabel(item.title));
    });

    // 2. 슬롯 (DOM 순서 = bundle_products 등록 순서)
    (slotEls || []).forEach(function (slotEl) {
      var slotId = slotEl.getAttribute('data-slot-id');
      var s = slotState[slotId];
      if (!s || !s.variantId) return;
      var productTitle = slotEl.getAttribute('data-product-title') || '';
      ids.push(s.variantId);
      // 도수는 괄호로 감싼다 — 상품명 자체에 하이픈이 들어갈 수 있어(예: "…1Day - グレー")
      // 하이픈으로 이으면 도수의 마이너스와 겹쳐 읽기 어려워진다.
      labels.push(sanitizeLabel(s.power ? (productTitle + ' (' + s.power + ')') : productTitle));
    });

    return [{
      id: data.bundleMain.variantId,
      quantity: 1,
      properties: {
        _bundle_items: ids.join(','),
        _bundle_labels: labels.join(LABEL_SEPARATOR),
        _bundle_v: '2'
      }
    }];
  }

  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('hidden');
  }
  function hideError(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
  }

  function initAll() {
    $$('[data-section-type="bundle-product"]').forEach(init);
  }

  window.BundleProduct = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section reload (Customize editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="bundle-product"]');
    if (section) init(section);
  });
})();
